/**
 * description 网络资源视频
 * created by nxf
 * created on 2019-6-22
 */
'use strict';
angular.module('resCenClassifiedVideoModule', ['initVideoDataModule', 'resCenClassifiedVideoLeftModule', 'resCenterVideoRouterModule'])
    .controller('resCenVideoCtrl', ['$scope', '$timeout', '$q', '$element', '$window', '$stateParams', '$state', '$filter', 'trsHttpService', 'globleParamsSet', 'trsPrintService', 'modalDialog', 'resourceCenterService', 'trsspliceString', 'initPictureDataService', 'storageListenerService',
        function($scope, $timeout, $q, $element, $window, $stateParams, $state, $filter, trsHttpService, globleParamsSet, trsPrintService, modalDialog, resourceCenterService, trsspliceString, initPictureDataService, storageListenerService) {
            initStatus();
            initData();


            /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
            function initStatus() {
                $scope.page = { // 分页信息
                    CURRPAGE: 1,
                    PAGESIZE: 18, // globleParamsSet.setResourceCenterPageSize,
                    PAGECOUNT: '',
                    ITEMCOUNT: ''
                };
                // 初始化数据
                $scope.data = {
                    items: [], // 列表数组
                    selectedArray: [], // 当前的选择项
                    keywords: '', // 检索关键词
                    docType: {} // 属性类型
                };
                // 时长字段
                $scope.durationType = {
                    data: [{
                        dictName: '全部时长',
                        id: '0'
                    },
                    {
                        dictName: '1分钟以内',
                        id: '1'
                    },
                    {
                        dictName: '1-4分钟',
                        id: '2'
                    }, {
                        dictName: '4-6分钟',
                        id: '3'
                    }, {
                        dictName: '6分钟以上',
                        id: '4'
                    }
                    ],
                    curValue: {
                        dictName: '全部时长',
                        id: '0'
                    }
                };
                // 检索类型
                $scope.keyType = {
                    data: [{
                        dictName: '全部',
                        id: '0'
                    },
                    {
                        dictName: '标题',
                        id: '1'
                    }, {
                        dictName: '正文',
                        id: '2'
                    }],
                    curValue: {
                        dictName: '全部',
                        id: '0'
                    }
                };
                $scope.params = { // 列表参数
                    typeid: 'zyzx',
                    serviceid: 'videomateria',
                    modelId: 'findFromNavigation',
                    hybase_id: $stateParams.hybaseId,
                    media_id: $stateParams.mediaId,
                    pageNum: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE
                };
                $scope.keyword = {
                    time: '', // 时间范围
                    timelength: '', // 时长
                    belongid: '', // 归属id
                    searchType: '', // 搜索类型
                    keywords: '', // 检索关键词
                    medianame: $state.params.medianame
                };
                $scope.basicParams = {
                    channelName: 'jtcpg',
                    indexName: '',
                    typeName: $stateParams.typename,
                    nodeId: $stateParams.nodeid,
                };
                //   $scope.basicParams = initPictureDataService.getOriginData($stateParams.nodeid);
            }

            /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
            function initData() {
                listenStorage();
                requestData();
                getBelongingType();
            }

            /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
            function listenStorage() {
                storageListenerService.listenResource(function() {
                    requestData();
                    storageListenerService.removeListener('resource');
                }, $scope);
            }

            /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
            function requestData() {
            // 初始化清空页面
                $scope.data.items = [];
                $scope.data.selectedArray = [];
                let params = angular.copy($scope.params);
                params.keyword = JSON.stringify($scope.keyword);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    $scope.page.CURRPAGE = data.summary_info.CURRPAGE;
                    $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT || 0;
                    $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                    $scope.basicParams.indexName = data.summary_info.indexName;
                    if (data.content.length > 0) {
                        $scope.data.items = data.content;
                        storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourcevideomaterialdetail');
                    }
                });

            }

            /**
         * [getBelongingType description] 请求类型
         * @return {[type]} [description]
         */
            function getBelongingType(){
                var deffer = $q.defer();
                let params = {
                    typeid: 'zyzx',
                    serviceid: 'videoMateria',
                    modelId: 'belongingType',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(typedata) {
                    $scope.data.docType = {
                        data: [{
                            dictName: '全部归属性质',
                            id: ''
                        }].concat(typedata),
                        curValue: {
                            dictName: '全部归属性质',
                            id: ''
                        }
                    };
                    deffer.resolve();

                });
                return deffer.promise;
            }

            /**
             * [getFilterVal description：获取过滤信息]
             * @param {Object} key 参数类型
             * @param {Object} val 需要的过滤数据
             */
            $scope.getFilterVal = function(key, val, val2) {
                switch (key) {
                    case 'time':
                    // 获取开始和结束时间
                        var st = $scope.data.untildate.replace(new RegExp('-', 'gm'), '/');
                        var et = $scope.data.fromdate.replace(new RegExp('-', 'gm'), '/');
                        if (st == '' && et == '') {
                            $scope.keyword.time = '';
                        } else {
                            $scope.keyword.time = st + ',' + et;
                        }
                        if ($scope.status.isrepetite && st == '') {
                            return;
                        }
                        break;
                    case 'timelength': // 时长
                        $scope.keyword.timelength = val;
                        break;
                    case 'belongid': // 归属性质
                        $scope.keyword.belongid = val;
                        break;
                    case 'keywords':
                    // 获取文件类型
                        $scope.keyword.keywords = val;
                        $scope.keyword.searchType = $scope.keyType.curValue.id;
                        break;
                }
                if ($scope.data.fromdate == '') {
                    $scope.status.isrepetite = true;
                } else {
                    $scope.status.isrepetite = false;
                }
                // 刷新列表
                requestData();
            };

            /**
             * [determineSelected description] 判断是否有选中稿件
             */
            function determineSelected() {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return false;

                } else {
                    return true;
                }
            }

            /**
             * [selectDoc description：选择视频
             *
             *
             */
            $scope.selectDoc = function(item) {
                var index = $scope.data.selectedArray.indexOf(item);
                if (index < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice(index, 1);
                }
            };

            /**
             * [collect description]收藏
             */
            $scope.collect = function() {
                if (!determineSelected()) {return;}
                var params = {
                    typeid: 'zyzx',
                    //                  methodname: 'batchPersonalMaterial',
                    serviceid: 'mlf_bigdataexchange',
                    channelName: 'wz',
                    typeName: $stateParams.typename,
                    nodeId: $stateParams.nodeid,
                    indexName: $scope.basicParams.indexName,
                    methodname: 'collect',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('收藏成功!', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
         * [printbtn description] 打印
         * @return {[type]} [description]
         */
            $scope.printbtn = function() {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件!', '', 'warning', false, '');
                    return;
                }
                var params;
                if ($scope.basicParams.channelName == 'gxgk') {
                    angular.forEach($scope.data.selectedArray, function(value, key) {
                        requestPrintVersion(value).then(function(data) {
                            requestPrintData(value, data);
                        });
                    });
                } else if ($scope.basicParams.channelName == 'tpg') {
                    params = {
                        serviceid: 'tpg',
                        modelid: 'bmtDetail',
                        typeid: 'zyzx',
                        docId: trsspliceString.spliceString($scope.data.selectedArray, 'DOC_ID', ',')
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        trsPrintService.trsPrintHistoryPictures(data);
                    // $scope.data.selectedArray = [];
                    });
                } else if ($scope.basicParams.channelName == 'jtcpg') {
                // params = {
                //     serviceid: $scope.basicParams.channelName,
                //     modelid: "dataDetail",
                //     guid: trsspliceString.spliceString($scope.data.selectedArray, "ZB_GUID", ","),
                //     typeid: "zyzx",
                // };
                    params = {
                        'typeid': 'zyzx',
                        'serviceid': 'jtcpg',
                        'modelid': 'detailData',
                        'indexName': $scope.basicParams.indexName,
                        'isDetail': true,
                        'typeName': 'push',
                        'guid': trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    };
                    // console.log(trsspliceString.spliceString($scope.data.selectedArray, "ZB_GUID", ","));
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        data.content.forEach(function(item) {
                            let img = "<img style='display:block;margin:0 auto;' src='" + item.IR_PRIVIEWPIC + "' />";
                            item.CONTENT = img + item.CONTENT;
                        });
                        trsPrintService.trsPrintBigData(data);


                    });
                }
            };

            /**
         * [requestPrintVersion description] 共享图片打印请求流程
         * @param  {[type]} item [description] 当前稿件
         * @return {[type]}      [description]
         */
            function requestPrintVersion(item) {
                var deferred = $q.defer();
                $scope.status.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
                    serviceid: 'mlf_metadatalog',
                    methodname: 'query',
                    MetaDataId: item.DOC_ID
                }, 'get').then(function(data) {
                    deferred.resolve(data.DATA);
                });
                return deferred.promise;
            }

            /**
         * [requestPrintData description] 共享图片打印请求详情
         * @param  {[type]} item    [description] 当前稿件
         * @param  {[type]} version [description] 当前稿件的流程
         * @return {[type]}         [description]
         */
            function requestPrintData(item, version) {
                var params = {
                    'serviceid': 'mlf_myrelease',
                    'methodname': $scope.status.methodname[item.DOCTYPEID],
                    'MetaDataId': item.DOC_ID
                };
                $scope.status.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    var result = data;
                    data.VERSION = version;
                    data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    $scope.data.printResult.push(result);
                    if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                        trsPrintService.trsPrintShare($scope.data.printResult);
                    // $scope.data.printResult = [];
                    }
                });
            }

            /**
             * [openReserveDraftModal description]预留
             */
            $scope.openReserveDraftModal = function() {
                if (!determineSelected()) {return;}
                var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.data.selectedArray);
                resCtrModalServiceModal.result.then(function(result) {
                    delete result.items;
                    var params = {
                        typeid: 'zyzx',
                        // methodname: 'batchPersonalMaterial',
                        serviceid: 'mlf_bigdataexchange',
                        channelName: 'wz',
                        typeName: $stateParams.typename,
                        nodeId: $stateParams.nodeid,
                        indexName: $scope.basicParams.indexName,
                        guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                        methodname: 'delay',
                        //                      SourceName: "资源中心-网站-%E6%94%BF%E6%B2%BB"
                    };
                    params = angular.extend(params, result);
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function() {
                            initOperFlag();
                        });
                    }, function() {

                        /* initOperFlag();
                        $scope.data.selectedArray = [];*/
                    });
                });
            };

            /**
             * [pageChanged description]分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.data.currPage = $scope.page.CURRPAGE;
                requestData();
                resourceCenterService.scrollTop($element);
            };
            $scope.selectPageNum = function() {
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.data.currPage = $scope.page.CURRPAGE;
                $scope.params.pageSize = $scope.page.PAGESIZE;
                requestData();
                resourceCenterService.scrollTop($element);
            };
            $scope.jumpToPage = function() {
                $scope.params.pageNum = $scope.data.currPage;
                $scope.page.CURRPAGE = $scope.data.currPage;
                requestData();
                resourceCenterService.scrollTop($element);
            };

            /**
             * [openPageForSearch description] 打开高级检索新页面
             * @return {[date]} [description]
             */
            $scope.openPageForSearch = function() {
                var url = $state.href('resadvancedsearch');
                window.open(url, '_blank');
            };
        }
    ]);
